import styles from './cardsRow.module.css'
import Card from "@/features/LoyaltySystemSection/ui/Card";

export default function CardsRow({promosByType}) {

    const birthdayPromo = promosByType.BIRTHDAY?.code ?? null;
    const firstPromo    = promosByType.FIRST?.code ?? null;
    const invitationPromo      = promosByType.INVITATION?.code ?? null;


    return (
        <div className={`${styles.cards} row`}>
            <Card
                description={"за отметку нас в социальных сетях (покажи отметку администратору при оплате)"}
                discount={10}
                isTermsCompleted={false}
                promo={''}
                noBtn={true}
            />
            <Card
                description={"на первую игру"}
                discount={20}
                isTermsCompleted={!!firstPromo}
                promo={firstPromo}
            />
            <Card
                description={"тебе в день рождения (а также за 3 дня до и 3 дня после)"}
                discount={50}
                isTermsCompleted={!!birthdayPromo}
                promo={birthdayPromo}
            />
            <Card
                description={"тебе за 5 приведенных друзей (делись своим промокодом с теми, кто еще не был у нас)"}
                discount={100}
                isTermsCompleted={!!invitationPromo}
                promo={invitationPromo}
            />
        </div>
    )
}